<template>
  <section class="about_style_3_area section_padding">
    <div class="container">
      <div class="row">
        <div class="col-md-4 col-sm-6">
          <div class="about_image_box"></div>
        </div><!--end .col-md-4-->
        <div class="col-md-3 col-sm-6">
          <div class="about_image_box about_image_box2"></div>
        </div><!--end .col-md-3-->
        <div class="col-md-5 col-sm-6">
          <div class="about_image_box about_image_box3"></div>
        </div><!--end .col-md-5-->

        <div class="col-md-4 col-sm-6">
          <div class="about_style_3_details">
            <h1>We guarantee our quality <span>100%</span></h1>
          </div><!--end .about_style_3_details-->
        </div><!--end .col-md-4-->
        <div class="col-md-4 col-sm-6">
          <div class="about_style_3_details">
            <img src="/assets/images/shape/about-shape.png" class="about_us_shape" alt="about shape">
            <p>Vest Plumbing is a fully licensed and insured plumbing company.  You can count on us for professional advice, top quality work and comprehensive service - even after a project is complete.</p>
          </div><!--end .about_style_3_details-->
        </div><!--end .col-md-4-->

        <div class="col-md-4 col-sm-6">
          <div class="about_style_3_details">
            <p>We have more than 40 years expereince proudly servicing the Decatur area! Our customers' trust is a srouce of great pride and inspires us to keep improving our business.  We're prepared to help you with any questions you may have or any situations you may encounter.</p>
          </div><!--end .about_style_3_details-->
        </div><!--end .col-md-4-->
      </div><!--end .row-->
    </div><!--end .container-->
  </section>
</template>

<script>
    export default {
      name: "AboutThree"
    }
</script>

<style scoped>

</style>
